import { CartLineFooter } from './CartLineFooter';

export type { TypeCartLineFooterProps } from './types';
export default CartLineFooter;
